import { Injectable, signal, WritableSignal } from '@angular/core';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class DismissibleItemStateService {
  private readonly states = new Map<string, WritableSignal<boolean>>();

  constructor(private localStorageService: LocalStorageService) {}

  isDismissed(key: string): boolean {
    return this.stateFor(key)();
  }

  dismiss(key: string): void {
    this.localStorageService.store(key, true);
    this.stateFor(key).set(true);
  }

  restore(key: string): void {
    this.localStorageService.remove(key);
    this.stateFor(key).set(false);
  }

  private stateFor(key: string): WritableSignal<boolean> {
    let state = this.states.get(key);
    if (!state) {
      state = signal(!!this.localStorageService.load(key));
      this.states.set(key, state);
    }

    return state;
  }
}
